export type IDisableFormActionButtons = ($elem: JQuery<HTMLElement>, disable?: boolean) => void;

export function disableFormActionButtons($elm: JQuery<HTMLElement>, disable: boolean = true) {
  const $form = $elm.closest('form');
  const $buttons = $form.find('.form-actions').find('.btn');

  if ($buttons) {
    $buttons.each((_, button) => {
      const $button = $(button);
      $button.prop('disabled', disable); // We can use .attr('disabled', 'false') method but jQuery .prop('disabled', true) method is recommended
    });
  }
}
